import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ICON_HEIGHT_72, IconSpinner } from '../../Icon'
import TextComponent from '../../Text'

import * as styles from './SearchLoader.module.css'

/**
 * @typedef {object} SearchLoaderTextProps
 *
 * @property {string} [className]
 *
 * @property {React.ReactNode} [children]
 *
 * @property {boolean} [isSecondary]
 */

/**
 * @typedef {object} SearchLoaderProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<SVGProps>} [Icon]
 *
 * @property {React.ComponentType<SearchLoaderTextProps>} [Text]
 *
 * @property {string} [className]
 *
 * @property {SVGProps} [iconProps]
 *
 * @property {string} [text]
 *
 * @property {SearchLoaderTextProps} [textProps]
 */

/**
 * @param {SearchLoaderProps} props
 */
function SearchLoader({
  Element = 'div',
  Icon = IconSpinner,
  Text = TextComponent,
  className = styles.SearchLoader,
  iconProps: { size = ICON_HEIGHT_72, ...iconProps } = EMPTY_OBJECT,
  text = 'Search.LoaderTextKey',
  textProps: {
    className: textClassName = styles.text,
    isSecondary: isSecondaryText = true,
    ...textProps
  } = EMPTY_OBJECT,
  ...elementProps
}) {
  const { t } = useTranslation()

  return (
    <Element {...elementProps} className={className}>
      <Icon {...iconProps} size={size} />
      <Text
        {...textProps}
        className={textClassName}
        isSecondary={isSecondaryText}
      >
        {t(text)}
      </Text>
    </Element>
  )
}

export default SearchLoader
